import { API_ENDPOINT_NAMES, STATUSES } from "../../util/constants";

let showAlert = (message, severity) => {};

export const setAlertFunction = (alertFunc) => {
  showAlert = alertFunc;
};

export const alertMiddleware = store => next => action => {
  const result = next(action);

  const actionTypesToConsider = [
    'graphqlApi/executeQuery/fulfilled',
    'graphqlApi/executeQuery/rejected',
    'graphqlApi/executeMutation/fulfilled',
    'graphqlApi/executeMutation/rejected',
  ];

  const successMsgEndpointWhitelist = [
    API_ENDPOINT_NAMES.createUser,
  ]

  let message = ''
  let severity = ''

  if (action.type.includes('rejected')) {
    message = action.error.message ?? 'Failed to complete request.';
    severity = STATUSES.ERROR;
  } else if (action.type.includes('fulfilled')) {
    message = action?.payload[action?.meta?.arg?.endpointName]?.message ?? 'Task completed successfully.';
    severity = STATUSES.SUCCESS;
  } else {
    message = "Unknown error. Please contact an administrator."
    severity = STATUSES.WARNING;
  }

  if (actionTypesToConsider.includes(action.type)) {
    if (action.type.includes('rejected') || (action.type.includes('fulfilled') && successMsgEndpointWhitelist.includes(action.meta?.arg?.endpointName))) {
      showAlert(message, severity);
    }
  }

  return result;
};